import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import Loading from "../components/LoaderComponent";
import SecurityUtils from "./SecurityUtils";

class Loader {
  private static instance: Loader; //Stores the singleton instance.
  private isLoading = false;

  private constructor() {} // Prevents direct instantiation of the class.

  static getInstance() {
    if (!Loader.instance) {
      Loader.instance = new Loader();
    }
    return Loader.instance;
  }

  showLoading(message?: string) {
    if (!this.isLoading) {
      this.isLoading = true;
      const loadingElement = document.createElement("div");
      loadingElement.id = "loading-root";
      document.body.appendChild(loadingElement);

      ReactDOM.render(<Loading message={message} />, loadingElement);
    }
  }

  dismissLoading() {
    if (this.isLoading) {
      this.isLoading = false;
      const loadingElement = document.getElementById("loading-root");
      if (loadingElement) {
        ReactDOM.unmountComponentAtNode(loadingElement);
        document.body.removeChild(loadingElement);
      }
    }
  }
}

// LocalStorage.ts
export class LocalStorage {
  static setLocalData(key: string, value: string): void {
    try {
      const encoded = btoa(encodeURIComponent(value));
      sessionStorage.setItem(key, encoded);
    } catch (error) {
      // Logger.error("Failed to store data:, ${error}");
    }
  }

  static getLocalData(key: string): string | null {
    const storedValue = sessionStorage.getItem(key);
    if (!storedValue) return null;

    try {
      return decodeURIComponent(atob(storedValue));
    } catch (error) {
      // Logger.error(Failed to decode value: ${error});
      return null;
    }
  }

  static removeLocalData(key: string): void {
    sessionStorage.removeItem(key);
  }

  static deleteAllLocalData(): void {
    sessionStorage.clear();
  }
}
export default Loader.getInstance();
export class RegionLocalStorage {
  static setLocalData(key: string, value: string): void {
    // Store raw value without encoding
    localStorage.setItem(key, value);
  }
  static getLocalData(key: string): string | null {
    const storedValue = localStorage.getItem(key);
    // Read raw value
    return storedValue;
  }
  static removeRegionLocalData(): void {
    localStorage.removeItem("region");
  }
}
export class UserDeviceStorage {
  private static STORAGE_KEY = "user_devices";

  // Get the current user-device map (decoded from Base64)
  private static getAll(): Record<string, string> {
    const encodedData = localStorage.getItem(UserDeviceStorage.STORAGE_KEY);
    if (!encodedData) return {};

    try {
      const decoded = atob(encodedData);
      return JSON.parse(decoded);
    } catch (error) {
      // Logger.error("Error decoding user_devices:", error);
      return {};
    }
  }

  // Save the user-device map (Base64 encoded)
  private static saveAll(userDevices: Record<string, string>) {
    try {
      const json = JSON.stringify(userDevices);
      const encoded = btoa(json);
      localStorage.setItem(this.STORAGE_KEY, encoded);
    } catch (error) {
      // Logger.error("Error encoding user_devices:", error);
    }
  }

  // Set device ID only if different email is provided (replaces the whole map)
  static setDeviceId(userId: string, deviceId: string): void {
    const currentData = this.getAll();
    const currentEmail = Object.keys(currentData)[0];

    if (currentEmail === userId) return;

    const newUserDevices: Record<string, string> = {
      [userId]: deviceId,
    };

    this.saveAll(newUserDevices);
  }

  // Get device ID for a specific user
  static getDeviceId(userId: string): string | null {
    const userDevices = this.getAll();
    return userDevices[userId] ?? null;
  }
}
